import { message } from "antd";
import { useState } from "react";
import { authApis } from "../../../services/authApi";
import AuthLayout from "../../../components/auth/authLayout";
import { setAccessToken } from "../../../helper/localStorage";
import "./index.scss";
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
    const [valueForm, setValueForm] = useState({
        email: "",
    });

    const onChangeValue = (values) => {
        setValueForm({
            ...valueForm,
            [values.target.name]: values.target.value,
        });
    };

    const onSubmit = async (event) => {
        event.preventDefault();
        if (!valueForm.email) {
            message.error("Xin vui lòng nhập email");
            return;
        }
        const res = await authApis
            .login(valueForm)
            .then((data) => {
                if (data.status_code === 200) {
                    message.success(data.message);
                    setAccessToken(data.token);
                } else if (data.status_code == 500) {
                    message.error(data.message);
                }
            })
            .catch((errors) => {
                console.log(errors);
            });
        return res;
    };

    return (
        <AuthLayout>
            <div class="col-lg-12">
                <div class="p-4">
                    <div class="text-center">
                        <h3
                            class="h5 text-gray-900 mb-4"
                            style={{ fontWeight: "bold" }}
                        >
                            Forgot password
                        </h3>
                    </div>
                    <form class="user" onSubmit={ onSubmit }>
                        <div class="form-group">
                            <input
                                type="email"
                                class="form-control"
                                id="exampleInputEmail"
                                aria-describedby="emailHelp"
                                placeholder="Email"
                                name="email"
                                onChange={ onChangeValue }
                            />
                        </div>
                        <div class="form-group">
                            <div class="d-flex justify-content-end align-items-center">
                                <button
                                    type="submit"
                                    class="btn"
                                    style={{
                                        color: "white",
                                        background: "black",
                                        padding: "5px 20px",
                                    }}
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </form>
                    <div class="text-left">
                        <Link
                            class="small"
                            to="/login"
                            style={{ color: "red" }}
                        >
                            Already have an account? Login!
                        </Link>
                    </div>
                    <div class="text-left">
                        <Link
                            class="small"
                            to="/register"
                            style={{ color: "black" }}
                        >
                            Register a new membership
                        </Link>
                    </div>
                </div>
            </div>
        </AuthLayout>
    );
};

export default ForgotPassword;
